import React from "react";
import { Editor } from "@tinymce/tinymce-react";

const ContentEditor = ({ value, onChange }) => {
    return (
        <Editor
            tinymceScriptSrc="/tinymce/tinymce.min.js"
            value={value}
            onEditorChange={onChange}
            init={{
                license_key: "gpl",

                plugins:
                    "advlist autolink lists link image charmap preview anchor " +
                    "searchreplace visualblocks code fullscreen insertdatetime media " +
                    "table help wordcount",

                toolbar1:
                    "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | " +
                    "bullist numlist outdent indent | link image media | removeformat | code preview",

                toolbar2:
                    "insertdatetime | table | hr visualblocks fullscreen | styles | strikethrough underline | help",

                height: 800,
                toolbar_sticky: true,
                toolbar_sticky_offset: 70,

                relative_urls: false,
                remove_script_host: false,
                convert_urls: true,

                branding: false,
                promotion: false,

                content_style:
                    "body { font-family: Helvetica, Arial, sans-serif; font-size: 16px; }",
            }}
        />
    );
};

export default ContentEditor;